export default {
  name: 'pc-title',
  props: {
    widgets: {
      type: Object,
      default: function _default() {
        return {
          title: '标题',
          icon: 'el-icon-c-scale-to-original',
          content: {
            label: '标题',
            size: 16,
            bold: false,
            color: '#333',
            align: 'text-left'
          },
          config: [{
            label: '标题',
            name: 'label',
            type: 'input',
            value: ''
          }, {
            label: '大小',
            name: 'size',
            type: 'number',
            value: ''
          }, {
            label: '是否加粗',
            name: 'bold',
            type: 'switch',
            value: ''
          }, {
            label: '文字颜色',
            name: 'color',
            type: 'color',
            value: ''
          }, {
            label: '对齐方向',
            name: 'align',
            type: 'radio-button',
            options: [{
              label: '文字居左',
              value: 'text-left'
            }, {
              label: '文字居中',
              value: 'text-center'
            }, {
              label: '文字居右',
              value: 'text-right'
            }]
          }]
        };
      }
    }
  },
  data: function data() {
    return {};
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  methods: {}
};